import React, { useState, useCallback, useEffect, useRef } from 'react';
import Filter from '@/pages/intelligence/components/Filter';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi from '@/pages/intelligence/hooks/useMarketSelector';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import useGenreComponent from '@/pages/intelligence/hooks/useGenreComponent';
import { fetchGamesOwnedGenerData } from '@/pages/intelligence/services/companies';
import {
  getFilterExtendDefaultValue,
  updateInputListRegionOptions,
} from '@intelligence/utils/filterUtils';
import { COMBINEID_REG } from '@intelligence/utils/constant';

export default function ActiveuserDetailFilter(props: any) {
  const {
    filterConfirm,
    filterReset,
    filterInit,
    buttonLogConfig,
    iconText,
    onFilterInit,
    companyId,
  } = props;

  const defaultValue = {
    [filterKeyMap.REGION]: {
      regions: [],
      markets: ['global'],
      type: 'market',
    },
    [filterKeyMap.GENRETOR]: {
      source: 'annie',
      mainGenres: [],
      subGenres: [],
    },
  };

  function createFetchCascaderGenres(companyId: string): (params: any) => Promise<any> {
    return async () => {
      // 添加ID校验规则
      if (COMBINEID_REG.test(companyId)) {
        const res = await fetchGamesOwnedGenerData({
          company_id: companyId,
        });
        const annirData = res?.data;
        const newAnnirData = annirData?.map((item: any) => {
          const newSubGenre = item?.sub_genre?.map((subItem: string) => {
            return {
              genre: subItem,
              genre_cn: subItem,
              genre_en: subItem,
            };
          });
          return {
            main_genre: {
              genre: item?.genre,
              genre_cn: item?.genre,
              genre_en: item?.genre,
            },
            sub_genre: newSubGenre || [],
          };
        });
        // 只有annie数据
        return {
          data: {
            annir: newAnnirData,
            ieg: null,
          },
        };
      }
    };
  }

  // 继承逻辑在这写
  // formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const extendDefaultFilterValue = getFilterExtendDefaultValue(
    isOperateDetail,
    detailFilterExtend,
    defaultValue,
  );
  const extendDefaultValue = !isOperateDetail
    ? defaultValue
    : {
        [filterKeyMap.REGION]: extendDefaultFilterValue?.[filterKeyMap.REGION],
        [filterKeyMap.GENRETOR]: extendDefaultFilterValue?.[filterKeyMap.GENRETOR],
      };

  const [formValue, setFormValue] = useState(extendDefaultValue);

  const {
    genreRef,
    genreSource,
    mainGenres,
    subGenres,

    handleGenresChange,
    handleReset: handleGenresReset,
    getGenresReqParams,
    updateGenres2Store,
  } = useGenreComponent(props);

  const [inputList, setInputList] = useState([
    {
      key: filterKeyMap.REGION,
      default: defaultValue[filterKeyMap.REGION],
      visible: 1,
      options: [],
      isTopCompanies: true,
    },
    {
      extendFilterType: 'game-owned-genre',
      key: filterKeyMap.GENRETOR,
      default: defaultValue[filterKeyMap.GENRETOR],
      disableIegg: true,
      fetchAction: createFetchCascaderGenres(companyId),
      genreData: {
        genreRef,
        genreSource,
        mainGenres,
        subGenres,
        handleGenresChange,
        handleGenresReset,
      },
    },
  ]);

  /** 优化TODO：这一整块及inputList里的国家参数都放到model里 */
  const { filterLoading, regionOptions } = useMarketFilterApi({});

  useEffect(() => {
    if (onFilterInit instanceof Function) {
      onFilterInit({
        loading: filterLoading,
        regionOptions,
      });
    }
  }, [filterLoading, regionOptions]);

  useEffect(() => {
    /** 国家筛选器的列表值 */
    if (regionOptions) {
      const updateRegionOptionInput = updateInputListRegionOptions({
        inputList,
        regionOptions,
        regionKey: filterKeyMap.REGION,
      });
      setInputList(updateRegionOptionInput);
    }
  }, [regionOptions]);

  const onConfirm = useCallback(
    (value /** 筛选器数据 */, apiValue /** 筛选器转换后的数据 */) => {
      setFormValue(value);
      const filterForm = {
        region_type: apiValue[filterKeyMap.REGION]?.region_type, // 默认都是market
        regions: apiValue[filterKeyMap.REGION]?.regions,

        // genre: apiValue[filterKeyMap.GENRETOR]?.genre, //TODO在父组件里通过source只留annie或iegg的2个字段
        sub_genre: apiValue[filterKeyMap.GENRETOR]?.sub_genre,
        // genre_source: apiValue[filterKeyMap.GENRETOR]?.genre_source,
        // iegg_genre_req: apiValue[filterKeyMap.GENRETOR]?.iegg_genre_req,
      };
      filterConfirm(filterForm);
      setDetailFilterExtend(apiValue);
    },
    [filterConfirm],
  );

  return (
    <Filter
      value={formValue}
      inputList={inputList}
      // onInit={onInit}
      onConfirm={onConfirm}
      onReset={() => {}}
      showButton={false}
    />
  );
}
